module.exports = __webpack_public_path__ + "img/blacksmith64_ua.1f2ed2b8.webp";